<template>
  <div>
    <el-card>
      <div class="add_box">
        <el-form
          :model="this.list"
          :rules="toEdRule"
          :label-position="labelPosition"
          ref="ruleForm"
        >
          <el-row>
            <el-col :span="10">
              <el-form-item label="是否轮播" prop="isRotation">
                <el-select
                  placeholder="请选择"
                  v-model="list.isRotation"
                  clearable
                >
                  <el-option
                    v-for="item in homeLun"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="开始时间" prop="startDate">
                <el-date-picker
                  v-model="list.startDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="结束时间" prop="startDate">
                <el-date-picker
                  v-model="list.endDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="活动名称" prop="activityName">
                <el-input
                  placeholder="请输入内容"
                  v-model="list.activityName"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="活动介绍" prop="introduce">
                <el-input
                  type="textarea"
                  :rows="10"
                  placeholder="请输入内容"
                  v-model="list.introduce"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="封面图" prop="coverUrl" ref="coverUrl">
                <el-upload
                  class="avatar-uploader"
                  :action="serverUrl"
                  :headers="header"
                  name="img"
                  :auto-upload="true"
                  :show-file-list="false"
                  :on-success="upSuccess"
                >
                  <img
                    v-if="list.coverUrl"
                    :src="list.coverUrl"
                    class="avatar"
                    style="width: 100%; height: auto"
                  />

                  <i
                    :class="
                      loadUpt
                        ? 'el-icon-loading'
                        : 'el-icon-plus avatar-uploader-icon'
                    "
                    style="margintop: 10px; font-size: 50px"
                    v-else
                  ></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-button
              style="margin-left: 600px"
              type="primary"
              @click="submitEdit('ruleForm')"
              >保存</el-button
            >
          </el-row>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import {baseURL} from '../../api/config'
export default {
  props: ["Changedata"],

  data() {
    return {
      loadUpt: false,
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      list: [],
      labelPosition: "top",
      toEdRule: {
        activityName: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        coverUrl: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        introduce: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        startDate: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        endDate: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
        isRotation: [
          { required: true, message: "内容不能为空", trigger: "change" },
        ],
      },
      //是否轮播--下拉框：
      homeLun: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "不是",
        },
      ],
    };
  },
  methods: {
    upSuccess(file) {
      this.list.coverUrl = file.entity;
      if (file.entity) {
        this.$refs.coverUrl.clearValidate();
      }
    },
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
    },
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        var startDate = this.formatDate(new Date(this.list.startDate));
        var endDate = this.formatDate(new Date(this.list.endDate));
        this.postAxios("/wenjuan/update", {
          id: this.list.id,
          coverUrl: this.list.coverUrl,
          activityName: this.list.activityName,
          introduce: this.list.introduce,
          startDate: startDate,
          endDate: endDate,
          isRotation:this.list.isRotation
        }).then((res) => {
          if (res.success) {
            this.$message.success(res.message);
          } else if (res.success == false) {
            this.$message.error(res.message);
          } else if (res.success == false && res.statusCode == "401") {
            this.$message.error(res.message);
            this.$router.push("/");
          }
        });
      });
    },
  },
  mounted() {
    this.list = this.Changedata;
    console.log(this.list, "8");
  },
  watch: {
    Changedata(newVal, oldVal) {
      this.list = newVal;
      console.log(newVal, "-------");
    },
  },
};
</script>